import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { SERVICES, SITE } from "@/data/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Inquiry() {
  const [form, setForm] = useState({
    name: "", email: "", phone: "", company: "",
    service: SERVICES[0].title, message: "",
  });
  const [sending, setSending] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      if (e.detail?.service) setForm((f) => ({ ...f, service: e.detail.service }));
    };
    window.addEventListener("mit:prefillInquiry", handler);
    return () => window.removeEventListener("mit:prefillInquiry", handler);
  }, []);

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  async function submit(e) {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Please fill your name, email and a short message.");
      return;
    }
    setSending(true);
    try {
      await axios.post(`${API}/inquiries`, form);
      toast.success("Received — a confirmation is on its way to your inbox.");
      setForm({ name: "", email: "", phone: "", company: "", service: SERVICES[0].title, message: "" });
    } catch (err) {
      toast.error("Something went wrong. Please try again or email info@mitllp.com.");
    } finally {
      setSending(false);
    }
  }

  return (
    <section id="inquiry" className="relative py-32 md:py-48 bg-[#EDE6D2] border-y border-[#0A0A14]/12" data-testid="inquiry">
      <div className="container-mit grid grid-cols-1 md:grid-cols-12 gap-14">
        <div className="md:col-span-5">
          <p className="text-[11px] tracking-[0.4em] text-[#A4801C] mb-6">— START A CONVERSATION</p>
          <h2 className="font-display text-5xl md:text-6xl font-light leading-[1.03] text-[#0A0A14] mb-8">
            Tell us where you are.<br /> We'll help you get where you're going.
          </h2>
          <div className="space-y-4 text-[#0A0A14]/70">
            <div className="flex justify-between border-b border-[#0A0A14]/12 pb-3">
              <span className="text-[#0A0A14]/55 text-sm">Service inquiries</span>
              <a href={`tel:${SITE.phones.service.replace(/\s+/g, "")}`} className="text-[#0A0A14] hover:text-[#4B1EAD]">{SITE.phones.service}</a>
            </div>
            <div className="flex justify-between border-b border-[#0A0A14]/12 pb-3">
              <span className="text-[#0A0A14]/55 text-sm">Email</span>
              <a href={`mailto:${SITE.emails.info}`} className="text-[#0A0A14] hover:text-[#4B1EAD]">{SITE.emails.info}</a>
            </div>
            <div className="flex justify-between border-b border-[#0A0A14]/12 pb-3">
              <span className="text-[#0A0A14]/55 text-sm">Website</span>
              <span className="text-[#0A0A14]">{SITE.website}</span>
            </div>
          </div>
        </div>

        <form onSubmit={submit} className="md:col-span-7 grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="inquiry-form">
          <div className="md:col-span-1">
            <label className="text-[10px] tracking-[0.3em] text-[#0A0A14]/50 uppercase">Name</label>
            <input className="input-editorial" value={form.name} onChange={update("name")} placeholder="Your full name" data-testid="inq-name" />
          </div>
          <div className="md:col-span-1">
            <label className="text-[10px] tracking-[0.3em] text-[#0A0A14]/50 uppercase">Email</label>
            <input type="email" className="input-editorial" value={form.email} onChange={update("email")} placeholder="you@company.com" data-testid="inq-email" />
          </div>
          <div className="md:col-span-1">
            <label className="text-[10px] tracking-[0.3em] text-[#0A0A14]/50 uppercase">Phone</label>
            <input className="input-editorial" value={form.phone} onChange={update("phone")} placeholder="+91 …" data-testid="inq-phone" />
          </div>
          <div className="md:col-span-1">
            <label className="text-[10px] tracking-[0.3em] text-[#0A0A14]/50 uppercase">Company</label>
            <input className="input-editorial" value={form.company} onChange={update("company")} placeholder="Optional" data-testid="inq-company" />
          </div>
          <div className="md:col-span-2">
            <label className="text-[10px] tracking-[0.3em] text-[#0A0A14]/50 uppercase">Service</label>
            <select className="input-editorial appearance-none" value={form.service} onChange={update("service")} data-testid="inq-service" style={{ backgroundColor: "transparent" }}>
              {SERVICES.map((s) => (
                <option key={s.id} value={s.title} className="bg-white text-[#0A0A14]">{s.title}</option>
              ))}
            </select>
          </div>
          <div className="md:col-span-2">
            <label className="text-[10px] tracking-[0.3em] text-[#0A0A14]/50 uppercase">Message</label>
            <textarea rows={5} className="input-editorial resize-none" value={form.message} onChange={update("message")} placeholder="Team size, timeline, and what you're trying to shift…" data-testid="inq-message" />
          </div>
          <div className="md:col-span-2 flex items-center justify-between mt-2">
            <p className="text-[11px] text-[#0A0A14]/50">A copy will be sent to your email · Reply within 1 business day.</p>
            <button type="submit" disabled={sending} className="btn-solid-gold" data-testid="inq-submit">
              {sending ? "Sending…" : "Send Inquiry"}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}
